module.exports = __webpack_public_path__ + "img/info_book.72691a55.png";